import React, { useState, useEffect } from 'react';
import { CustomRedirect } from '@/components/navigation';
import { getDocument } from '@/services/documents';
import { getExternalAgreement } from '@/services/external-agreements';
import { useIsBuyer } from '@/utils/hooks';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';

type objectType = 'project-documents' | 'documents' | 'external-agreements' | 'buyer-options';

async function getProjectId(type: objectType, objectId: string | number) {
    switch (type) {
        case 'project-documents':
        case 'documents':
            return (await getDocument(objectId as string)).projectId;
        //TODO OPTIONSV2: do we need to fix this?
        // case 'buyer-options':
        //     return (await getCatalogLinkGroup(objectId as number)).projectId;
        case 'external-agreements':
            return (await getExternalAgreement(objectId as number)).projectId;
        default:
            return null;
    }
}

const ExternalLinkTasksRouting: React.FC<{
    type: objectType;
    objectId: number | string;
}> = ({ type, objectId }) => {
    const isBuyer = useIsBuyer();

    const [projectId, setProjectId] = useState<number | null>(null);

    useEffect(() => {
        async function load() {
            setProjectId(await getProjectId(type, objectId));
        }

        if (!isBuyer) {
            load();
        }
    }, [objectId, isBuyer, type]);

    if (isBuyer) {
        return null;
    }

    if (!projectId) {
        return <LoadingIndicator />;
    }

    return (
        <CustomRedirect to={`/projects/${projectId}/${type === 'buyer-options' ? 'options' : type}/rejected/${objectId}`} />
    );
};

export default ExternalLinkTasksRouting;
